import { ENGLISH_TRANSLATE } from "assets/translate/en";
import { SPANISH_TRANSLATE } from "assets/translate/es";
import { PORTUGUESE_TRANSLATE } from "assets/translate/pt";
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import { LANGUAGES } from "constants/Languages";
import { getLanguageLocalStorage, setLanguageLocalStorange } from "redux/services/StorageServices";

const oResources = {
    en: {
        translation: ENGLISH_TRANSLATE
    },
    es: {
        translation: SPANISH_TRANSLATE
    },
    pt: {
        translation: PORTUGUESE_TRANSLATE
    }
};

let sLanguage = LANGUAGES.SPANISH;

i18n.use(initReactI18next).init({
    resources: oResources,
    lng: sLanguage,
    interpolation: {
        escapeValue: false
    }
});

getLanguageLocalStorage().then(oSuccess => {
    if (oSuccess) {
        sLanguage = oSuccess;
        i18n.changeLanguage(sLanguage);
    } else {
        setLanguageLocalStorange(sLanguage);
    }
});

export default i18n;